import './ServiceCard.css';
import service1 from "../Assets/BIScert.png"
import service2 from "../Assets/service2.jpg"
import service3 from "../Assets/service3.png"
import service4 from "../Assets/service4.png"
import service5 from "../Assets/service5.jpg"
import service6 from "../Assets/service6.png"

function ServiceCard() {
  const services = [
    {
      title: 'BIS Certification Consultation',
      description:
        'Expert guidance throughout the entire BIS certification process, ensuring compliance with all regulatory requirements within 30 days as per simplified procedure of BIS.',
      image: service1,
    },
    {
      title: 'Foreign Manufacturer BIS Certification',
      description:
        'From product assessment till grant of license full support including inspection assistance for a foreign manufacturer by FMCS.',
      image: service2,
    },
    {
      title: 'Lab  Testing Co-ordination',
      description:
        'We provide Cost effective and flawless Lab testing services required for BIS certification through our NABL / BIS Certified partners to ensure smooth processing of BIS certification.',
      image: service3,
    },
    {
      title: 'Testing Equipment Manufacturing & Trading',
      description: (
        <>
          We Design, Manufacture and Trade equipment, Chemicals, Glassware
          required for in-house lab as per BIS standards by E Cube International
          through{' '}
          <a
            href="https://www.jadaayu.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.jadaayu.com
          </a>
        </>
      ),
      image: service6,
    },
    {
      title: 'Service as a Product (SaaP)',
      description:
        'We provide SaaP to all our clients by providing after license services like mock inspections, document verification, OSL testing and inspection support.',
      image: service4,
    },
    {
      title: 'Software Solutions for Industry',
      description:
        'We provide software solutions to maintain data of testing as per the scheme of testing of BIS which can be patched to any ERP.',
      image: service5,
    },
  ];

  return (
    <div className='service'>
      <h2>OUR SERVICES</h2>
      <p className='service-para'>
        Comprehensive solutions for all your BIS Certification requirements
        from preliminary planning to grant of license including step-by-step
        consultation, laboratory installation and training.
      </p>

      <div className='service-card-container'>
        {services.map((service, index) => (
          <div className='service-card' key={index}>
            <div className='service-card-img'>
              <img src={service.image} alt='service' />
            </div>
            <div className='service-card-content'>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ServiceCard;
